import { inject } from '@angular/core';
import { PrivacyPolicyService } from './privacy-policy.service';
import { from, map, of, switchMap, tap } from 'rxjs';
import { ModalController } from '@ionic/angular';
import { PrivacyPolicyModalComponent } from './privacy-policy-modal/privacy-policy-modal.component';

export function hasAcceptedPrivacyPolicy() {
  const modalController = inject(ModalController);
  const privacyPolicyService = inject(PrivacyPolicyService);

  return privacyPolicyService.privacyPolicyAccepted$.pipe(
    switchMap((accepted) => {
      if (!accepted) {
        return from(
          modalController.create({
            component: PrivacyPolicyModalComponent,
            backdropDismiss: false,
          }),
        ).pipe(
          tap((modal) => modal.present()),
          map(() => false),
        );
      }
      return of(true);
    }),
  );
}
